import { AsyncPipe, JsonPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MomentModule } from 'ngx-moment';
import { BookingItemNamePipe } from '../../pipes/booking-item-name.pipe';
import { HlCurrencyPipe } from '../../pipes/hl-currency.pipe';
import { ConfigService } from '../../services/config.service';
import { Product } from 'src/app/models';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'tr[assign-items-table-row]',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    HlCurrencyPipe,
    MatSelectModule,
    MatOptionModule,
    AsyncPipe,
    BookingItemNamePipe,
    MomentModule
  ],
  template: `
    <ng-container [formGroup]="formRow()">
      <td>
        {{ formRow().value.quantity }}
      </td>
      <td>
        {{ formRow().value.bookingItem | bookingItemName: false : true }}
        @if (
          formRow().value.bookingItem.item &&
          formRow().value.bookingItem.item.notes
        ) {
          <p>
            <small
              ><strong>Item details:</strong>
              {{ formRow().value.bookingItem.item.notes }}</small
            >
          </p>
        }
        <p>
          <small
            ><strong>Notes:</strong>
            {{ formRow().value.bookingItem.notes }}</small
          >
        </p>
      </td>
      <td>
        <mat-form-field class="px-2">
          <mat-select required formControlName="item">
            @for (product of productItems(); track product.id) {
              <mat-optgroup [label]="product.name">
                @for (item of product.items; track item.id) {
                  <mat-option
                    [value]="item"
                    [disabled]="
                      item.status !== 'Available' ||
                      item.has_current_workshop_jobs
                    "
                  >
                    {{ item.code }}
                    @if (item.notes) {
                      <span> - {{ item.notes }}</span>
                    }
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          @if (itemControl().hasError('unavailable')) {
            <mat-error>{{ itemControl().errors['unavailable'] }} </mat-error>
          }
          @if (itemControl().hasError('duplicate')) {
            <mat-error>{{ itemControl().errors['duplicate'] }} </mat-error>
          }
          @if (itemControl().hasError('required')) {
            <mat-error>You must specify an item to continue </mat-error>
          }
        </mat-form-field>
      </td>
      <td class="on-hire" width="20%">
        {{ formRow().value.bookingItem.on_hire | amDateFormat: dateTimeFormat }}
      </td>
      <td class="off-hire" width="20%">
        @if (formRow().value.bookingItem.off_hire) {
          <span>
            {{
              formRow().value.bookingItem.off_hire
                | amDateFormat: dateTimeFormat
            }}
          </span>
        }
      </td>
      <td class="charge" width="10%">
        @if (
          formRow().value.bookingItem.charge || formRow().value.charge === 0
        ) {
          <span>
            {{
              formRow().value.bookingItem.charge
                | hlCurrency: null : 1 : false
                | async
            }}
          </span>
        }
      </td>
    </ng-container>
  `,
  styles: `
    :host {
      display: table-row;
    }
  `
})
export class AssignItemsTableRowComponent {
  index = input.required<number>();
  formRow = input.required<any>();
  itemControl = input.required<AbstractControl>();
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;
  productItems = input.required<Product[]>();
}
